import React, { FC, ReactNode } from 'react'

import { Button } from '../Button'
import * as S from './ConfirmationModal.styles'

interface ConfirmationModalProps {
  onClose: () => void
  onConfirm: () => void
  customMessage?: ReactNode
  customTitle?: string
  customCancelLabel?: string
  customConfirmLabel?: string
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  onClose,
  onConfirm,
  customMessage,
  customTitle,
  customCancelLabel,
  customConfirmLabel,
}) => {
  return (
    <S.StyledModal isFullScreen onCloseModal={onClose}>
      <S.ModalContent>
        <S.ModalConfirmation>{customTitle ?? 'Are you sure?'}</S.ModalConfirmation>
        <S.Text>{customMessage ?? 'This action can not be recovered'}</S.Text>
        <S.ButtonContainer>
          <Button.Secondary onClick={onConfirm} data-confirm-button>
            {customConfirmLabel || 'Confirm'}
          </Button.Secondary>
          <Button.Primary onClick={onClose} data-close-button>
            {customCancelLabel || 'Cancel'}
          </Button.Primary>
        </S.ButtonContainer>
      </S.ModalContent>
    </S.StyledModal>
  )
}
